import { InfiniteList } from '@src/design-system/molecules/infinite-list';
import { PROGRAM_STATUSES, type TProgram } from '@shared/types/program';
import { type ComponentProps, type ElementType, useRef } from 'react';
import { ItemInfo } from '@features/tasks/pages/create/item-info';
import programApi, {
  type TProgramQuery,
} from '@features/programs/services/program-api';

export const ProgramsList = ({
  onClickItem,
  isItemSelected,
  CloseListTrigger,
  props,
}: {
  onClickItem?: (item: TProgram, isSelected: boolean) => void;
  isItemSelected?: (item: TProgram) => boolean;
  CloseListTrigger?: ElementType;
  props?: {
    infiniteListProps?: Partial<
      ComponentProps<typeof InfiniteList<TProgram, TProgramQuery>>
    >;
    infoItemProps?: Partial<ComponentProps<typeof ItemInfo<TProgram>>>;
  };
}) => {
  const ref = useRef<HTMLButtonElement>(null);

  return (
    <>
      <InfiniteList<TProgram, Partial<TProgramQuery>>
        enableSearch
        fetchInfiniteData={programApi.useFetchInfinite}
        searchParamName='program'
        query={{ status: PROGRAM_STATUSES.active }}
        renderItem={(program) => {
          const isSelected = isItemSelected?.(program);
          return (
            <ItemInfo
              item={program}
              id={program.id}
              onClick={() => {
                ref.current?.click();
                onClickItem?.(program, !!isSelected);
              }}
              isSelected={isSelected}
              name={program.name}
              {...props?.infoItemProps}
            />
          );
        }}
        {...props?.infiniteListProps}
      />
      {CloseListTrigger && (
        <CloseListTrigger
          ref={ref}
          className='hidden'
        />
      )}
    </>
  );
};
